const setting = {
  passwordTitle: "Kata sandi",
  changePasswordBtn: "Ganti kata sandi",
  changePasswordTips:
    "Jika Anda lupa kata sandi atau ingin mengubahnya, Anda dapat melakukannya di sini; kami akan mengirimkan kode verifikasi ke alamat email terdaftar Anda, yang akan diverifikasi untuk mengonfirmasi identitas Anda, dan kemudian Anda dapat mengatur ulang kata sandi akun Anda.",
  feedbackTitle: "Umpan balik",
  feedbackBtn: "Berikan umpan balik",
  feedbackTips:
    "Agar kami dapat melayani Anda dengan lebih baik, Anda dapat menjelaskan masalah Anda harap kirimkan umpan balik Anda kepada kami dan tim layanan pelanggan kami akan menghubungi Anda sesegera mungkin.",
  appearanceTitle: "Tampilan",
  appearanceBtn: "Ubah Tampilan",
  appearanceTips:
    "Kami memilih dua mode tampilan untuk Anda, sehingga Anda dapat beralih antara mode gelap dan terang sesuai dengan preferensi Anda.",
  changePassWordModalTitle: "Ganti kata sandi",
  changePassWordSameErrorTips: "Kata sandi baru yang Anda masukkan sama dengan kata sandi lama Anda. Masukkan kata sandi yang berbeda",
  changePasswordCurrentErrorTips: "Kata sandi Anda tidak tepat. Silakan coba lagi.",
  currentPasswordLabel: "Kata sandi saat ini",
  newPasswordLabel: "Kata sandi baru",
  retypePasswordLabel: "Ketik ulang kata sandi baru",
  changePasswordSuccessTips: "Kata sandi Anda telah berhasil diubah.",
  changePasswordComfirmDiffErrorTips: "Silakan masukkan kata sandi yang sama di kedua bidang.",
  forgotPassword: "Lupa kata sandi?",
  feedbackModalSubtitle: "Terima kasih telah menghubungi kami dan memberi tahu kami pendapat Anda tentang produk!",
  feedBackModalProductQuestion: "Masalah seperti apa yang ingin Anda selesaikan dengan produk kami?",
  feedBackModalProductTypeSug: "Saran",
  feedBackModalProductTypeMem: "Pertanyaan terkait layanan anggota",
  feedBackModalProductTypeFun: "Pertanyaan fungsi",
  feedBackModalProductTypeReq: "Persyaratan Produk",
  feedBackModalProductTypeBug: "Umpan balik tentang bug produk",
  feedBackModalProductTypeIss: "Masalah kinerja",
  feedBackModalProductTypeRL: "Pertanyaan terkait pendaftaran dan login",
  feedBackModalProductTypeRef: "Layanan pengembalian dana",
  feedBackModalProductTypeOth: "Lainnya",
  feedBackModalProductSelectQuestion: "Masalah seperti apa yang ingin Anda selesaikan dengan produk kami?",
  feedBackModalProductContQuestion: "Masalah apa yang Anda temui saat menggunakan produk?",
  feedBackModalAddImageBtn: "Tambahkan gambar",
  feedBackModalTips: "Kiat:",
  feedBackModalTipsCont: "Karena perbedaan waktu layanan pelanggan global, kami akan membalas Anda dalam waktu 48 jam dari hari kerja;",
  feedBackSuccessTips: "Berhasil terkirim",
  feedBackSuccessSubTips: "Kami akan menyelesaikan masalah Anda sesegera mungkin",
  feedBackFailedTips: "Gagal mengirim",
  feedBackFailedSubTips: "Pastikan koneksi jaringan Anda berfungsi dan kirim lagi",
  appearanceLightMode: "Mode terang",
  appearanceDarkMode: "Mode gelap",
  promotionModalTitle: "Promosi",
  promoItem: "Item promo",
  promoCode: "Kode promosi",
  discount: "Diskon",
  applyBtn: "Terapkan",
  applyPromotionErrorTips: "Kode promo Anda tidak valid",
};

export default setting;
